import { ChevronRight, ExpandLess, ExpandMore } from '@mui/icons-material'
import { Box, Button, Card, CardContent, Collapse, Divider, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { useState } from 'react'

function ChooseBuild({ createNewConfig }: { createNewConfig: (config: "SIMPLE" | "ADVANCED") => void }) {
    const [open, setOpen] = useState(false)
    const tableOptions = [
        {
            text: t('configuration:tableDifference:date'),
            simple: t('yes'),
            advanced: t('yes')
        },
        {
            text: t('configuration:recipient'),
            simple: t('yes'),
            advanced: t('yes')
        },
        {
            text: t('configuration:tableDifference:speedFilter'),
            simple: t('yes'),
            advanced: t('yes')
        },
        {
            text: t('configuration:tableDifference:trackFilter'),
            simple: '-',
            advanced: t('yes')
        },
        {
            text: t('configuration:tableDifference:horseFilter'),
            simple: '-',
            advanced: t('yes')
        },
        {
            text: t('configuration:tableDifference:typeFilter'),
            simple: '-',
            advanced: t('yes')
        },
    ]
    return (
        <Box >
            <Divider sx={{ my: 2 }}></Divider>
            <Box display={'flex'} gap={1.5} alignItems={'center'} width={'100%'}>
                <Button sx={{ flex: 1 }} onClick={() => createNewConfig('SIMPLE')} variant='contained'>{t('configuration:simpleBuild')}</Button>
                <Button sx={{ flex: 1 }} onClick={() => createNewConfig('ADVANCED')} variant='outlined'>{t('configuration:advancedBuild')}</Button>
            </Box>
        </Box>
    )
}

export default ChooseBuild